import type { Article } from "../../support.types";

export type Props = {
  /** Previous article, or null if none */
  prev: Article | null;
  /** Next article, or null if none */
  next: Article | null;
  /** Callback when an article navigation button is clicked */
  onNavigate: (article: Article) => void;
  /** Render function for the previous button */
  renderPrevButton: (props: {
    article: Article;
    onClick: () => void;
  }) => React.ReactNode;
  /** Render function for the next button */
  renderNextButton: (props: {
    article: Article;
    onClick: () => void;
  }) => React.ReactNode;
  /** Optional className for the container */
  className?: string;
};

/**
 * Base component for article navigation (prev/next).
 * Uses render props for button styling - no CSS included.
 */
export function SupportArticleNavigationBase({
  prev,
  next,
  onNavigate,
  renderPrevButton,
  renderNextButton,
  className,
}: Props) {
  if (!prev && !next) {
    return null;
  }

  return (
    <nav
      className={className}
      aria-label="Article navigation"
      data-testid="support-article-navigation"
    >
      {prev &&
        renderPrevButton({
          article: prev,
          onClick: () => onNavigate(prev),
        })}
      {next &&
        renderNextButton({
          article: next,
          onClick: () => onNavigate(next),
        })}
    </nav>
  );
}

export default SupportArticleNavigationBase;

